import { useState } from "react";
import {
  TournamentStateNoticeBack,
  TournamentStateNoticeWrapper,
} from "./style";

interface TournamentStateNoticeProps {
  notice: string;
}
const TournamentStateNotice = ({ notice }: TournamentStateNoticeProps) => {
  const [more, setMore] = useState<boolean>(false);
  return (
    <TournamentStateNoticeWrapper>
      <div className="header">공지사항</div>
      <TournamentStateNoticeBack more={more} onClick={() => setMore(!more)}>
        <div className="content">{notice}</div>
        <img
          src={`/image-web/tournament/${more ? "up" : "down"}-arrow.svg`}
          alt="more"
        />
      </TournamentStateNoticeBack>
    </TournamentStateNoticeWrapper>
  );
};
export default TournamentStateNotice;
